/**
 * Browser detection utilities
 */

/**
 * Detects if the current browser is Safari
 * @returns {boolean} True if the browser is Safari
 */
export const isSafari = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

/**
 * Detects if the current browser is Chrome
 * @returns {boolean} True if the browser is Chrome
 */
export const isChrome = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /chrome/i.test(navigator.userAgent);
};

/**
 * Detects if the current browser is Firefox
 * @returns {boolean} True if the browser is Firefox
 */
export const isFirefox = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /firefox/i.test(navigator.userAgent);
};

/**
 * Detects if the current browser is Edge
 * @returns {boolean} True if the browser is Edge
 */
export const isEdge = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /edg/i.test(navigator.userAgent);
};
